import { render, staticRenderFns } from "./EditCompanyInfoModal.vue?vue&type=template&id=1dace55a&scoped=true&class=fill-height&"
import script from "./EditCompanyInfoModal.vue?vue&type=script&lang=ts&"
export * from "./EditCompanyInfoModal.vue?vue&type=script&lang=ts&"
import style0 from "./EditCompanyInfoModal.vue?vue&type=style&index=0&id=1dace55a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dace55a",
  null
  
)

export default component.exports